/* Exports helper functions */
export const provinceSelect = (postalCode) => {
	let province;

	switch (postalCode) {
		case 'A':
			province = 'nl';
			break;
		case 'B':
			province = 'ns';
			break;
		case 'C':
			province = 'pe';
			break;
		case 'E':
			province = 'nb';
			break;
		default:
			break;
	}

	return province;
}

export const formatData = (rawData, lang) => {
	let data = new FormData();

	data.append('lead_firstname', rawData.firstname);
	data.append('lead_lastname', rawData.lastname);
	data.append('lead_email', rawData.emailaddress);
	data.append('lead_province', rawData.province);
	data.append('lead_postalcode', rawData.postalcode);
	data.append('lead_heatpumptype', rawData.heatpumptype);
	data.append('lead_lowincome', rawData.lowincome);
	data.append('lead_casl', true);
	data.append('emco_rebate_calculator_submission', true);
	data.append('language', lang);

	return data;
}



// WEBPACK FOOTER //
// ./src/helpers/functions.js